import Home from '../components/home/Home.vue';
import Recipes from '../components/recipes/Recipes.vue';
import SurveyPage from '../components/surveys/SurveyPage';
import RecipesPage from '../components/recipes/RecipesPage';
import TipsPage from '../components/info/TipsPage';
import InfoPage from '../components/info/InfoPage.vue';
import Settings from '../components/profile/Settings';
import Logout from '../components/profile/Logout';
import Login from '../components/profile/Login';
import Registration from '../components/profile/Registration';
import ChangeEmail from '../components/profile/ChangeEmail';
import ChangePassword from '../components/profile/ChangePassword';
import ResetPassword from '../components/profile/ResetPassword';
import FinishResetPassword from '../components/profile/FinishResetPassword';
import Calendar from '../components/myschedule/Calendar';
import TimeBlock from '../components/myschedule/TimeBlock';
import Tips from '../components/info/Tips';
import Info from '../components/info/Info';
import FAQ from '../components/info/FAQ';
import Content from '../components/info/Content';
import Contact from '../components/info/Contact';
import Version from '../components/utilities/Version';
import { store } from '../state/store'
import FAQPage from '../components/info/FAQPage'
import AdvicePage from '../components/myschedule/AdvicePage'
import Dashboard from '../components/dashboard/Dashboard'

let onlyAllowAuthenticated = (to, from, next) => {
  console.info('Authenticated guard')
  if (store.getters.getAuthToken==='') {
    next({name: 'login'})
  } else {
    next()
  }
}

export const routes = [
  {
    path: '',
    name: 'home',
    component: Home,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/recipes/:cat_id',
    name: 'recipes',
    component: Recipes,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/recipe/:recipe_id',
    name: 'recipe',
    component: RecipesPage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/survey/:survey_id',
    name: 'survey',
    component: SurveyPage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/version',
    name: 'version',
    component: Version
  },
  {
    path: '/registration/:token',
    name: 'registration',
    component: Registration,
    props: true,
  },
  {
    path: '/changeemail',
    name: 'changeemail',
    component: ChangeEmail,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: ChangePassword,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/resetpassword',
    name: 'resetpassword',
    component: ResetPassword,
  },
  {
    path: '/resetlink/:token',
    name: 'resetlink',
    component: FinishResetPassword,
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/advice/:shift_type',
    name: 'advice',
    component: TimeBlock,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/adviceDetail/id/:advice_id/timeframe/:timeframe_id',
    name: 'advicepage',
    component: AdvicePage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/tips/:tip_id',
    name: 'tipspage',
    component: TipsPage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/tips',
    name: 'tips',
    component: Tips,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/info/:info_id',
    name: 'infopage',
    component: InfoPage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/info',
    name: 'info',
    component: Info,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/FAQ/:faq_id',
    name: 'faqpage',
    component: FAQPage,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/content/:name',
    name: 'content',
    component: Content,
    props: true,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    props: false,
    beforeEnter: onlyAllowAuthenticated,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    props: false,
    beforeEnter: onlyAllowAuthenticated,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js